// extracted by mini-css-extract-plugin
export default {"bar":"CrmPrompt_bar__OzBcc","text":"CrmPrompt_text__0Gi4D","actions":"CrmPrompt_actions__oWmAl","gold":"CrmPrompt_gold__SzBo3","link":"CrmPrompt_link__pFFtP"};